/**
 * SCIP Server API
 * SCIP Server
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ValidationDTO } from './validation-dto';
import { ProductInternalResponseDto } from './product-internal-response-dto';
import { OrganizationDto } from './organization-dto';


export interface DossierSearchResultDto { 
    /**
     * Dossier ID
     */
    dossierId: number;
    /**
     * Simplified submissions
     */
    simplifiedSubmissions: number;
    /**
     * Scip number
     */
    scipNumber: string;
    /**
     * Name
     */
    name: string;
    /**
     * Remarks
     */
    remarks: string;
    /**
     * Internal remarks
     */
    internalRemarks: string;
    /**
     * Submission number
     */
    submissionNumber: string;
    /**
     * Dossier submission status
     */
    status: DossierSearchResultDtoStatusEnum;
    /**
     * Submission date
     */
    submissionDate: string;
    /**
     * Filename
     */
    filename: string;
    /**
     * Report URL
     */
    reportUrl: string;
    org: OrganizationDto;
    /**
     * Requested type
     */
    requestedType: DossierSearchResultDtoRequestedTypeEnum;
    /**
     * Dossier type
     */
    type: DossierSearchResultDtoTypeEnum;
    /**
     * Parent identity
     */
    parentIdentity: string;
    /**
     * Validations
     */
    validations: Array<ValidationDTO>;
    /**
     * Parent parts product name
     */
    parentPartsProductName: string;
    /**
     * Updated at
     */
    updatedAt: string;
    product: ProductInternalResponseDto;
    /**
     * Echa submission response status
     */
    echaResponseStatus: DossierSearchResultDtoEchaResponseStatusEnum;
    /**
     * Echa submission response error text
     */
    echaResponseErrorText: string;
    /**
     * Organization group name
     */
    orgGroupName: string;
}
export enum DossierSearchResultDtoStatusEnum {
    DossierRequested = 'DOSSIER_REQUESTED',
    DossierFileInPreparation = 'DOSSIER_FILE_IN_PREPARATION',
    DossierFailedToCreate = 'DOSSIER_FAILED_TO_CREATE',
    DossierFileCreated = 'DOSSIER_FILE_CREATED',
    DossierSentToEcha = 'DOSSIER_SENT_TO_ECHA',
    Pending = 'PENDING',
    Submitted = 'SUBMITTED',
    AllPartsCompleted = 'ALL_PARTS_COMPLETED',
    OneOrMoreFailed = 'ONE_OR_MORE_FAILED',
    ValidationSucceeded = 'VALIDATION_SUCCEEDED',
    Failed = 'FAILED',
    ValidationFailed = 'VALIDATION_FAILED',
    DossierTooLarge = 'DOSSIER_TOO_LARGE'
};
export enum DossierSearchResultDtoRequestedTypeEnum {
    Standard = 'STANDARD',
    PartsOnly = 'PARTS_ONLY',
    Referencing = 'REFERENCING'
};
export enum DossierSearchResultDtoTypeEnum {
    Full = 'FULL',
    Simplified = 'SIMPLIFIED'
};
export enum DossierSearchResultDtoEchaResponseStatusEnum {
    ClientError = 'CLIENT_ERROR',
    FailedAuthenticationChecks = 'FAILED_AUTHENTICATION_CHECKS',
    FailedAuthorisationChecks = 'FAILED_AUTHORISATION_CHECKS',
    ServiceNotFound = 'SERVICE_NOT_FOUND',
    RefusedRequestUnsupportedFormat = 'REFUSED_REQUEST_UNSUPPORTED_FORMAT',
    ServerError = 'SERVER_ERROR',
    NetworkErrorWhileSubmitting = 'NETWORK_ERROR_WHILE_SUBMITTING',
    DossierFileCreationError = 'DOSSIER_FILE_CREATION_ERROR',
    UndefinedStatusCode = 'UNDEFINED_STATUS_CODE',
    DossierSentToEcha = 'DOSSIER_SENT_TO_ECHA'
};



